module.exports = __webpack_public_path__ + "img/Brand_mob_dropbox.3150f4ee.svg";